// @ts-nocheck
// @ts-strict-ignore
import { currencyFormat, percentageFormat } from '../../utils/formatter'
import { getValue, getArrayValue } from '../../utils/product-schema'

const hasSubscript = (text: string) => /\(([^)]+)\)/.exec(text)

/*
 * groups a sentence into 'big' and 'small' words depending on if the word includes a number
 */
export const autoFormat = (text: any) => {
  if (typeof text === 'boolean') {
    return [
      {
        size: 'small',
        word: text ? 'Yes' : 'No',
      },
    ]
  } else if (typeof text !== 'string') {
    return [
      {
        size: 'small',
        word: '-',
      },
    ]
  }

  return text
    .replace(/\b\//g, ' /')
    .split(/(?!\(.*)\s(?![^(]*?\))/g)
    .map(function (word) {
      return {
        word: word,
        size: !hasSubscript(word) && (/\d/.test(word) || word === '-') ? 'big' : 'small',
      }
    })
    .reduce(function (words, word, i) {
      if (i !== 0 && word.size === words[words.length - 1].size) {
        words[words.length - 1].word += ' '.concat(word.word)
        return words
      }

      return words.concat(word)
    }, [])
}

const applyFormat = (col) => {
  const format = {
    percentage: (v) => percentageFormat(v),
    currency: (v) => currencyFormat(v),
  }

  return {
    ...col,
    value: (format[col.formatter] || ((v) => v))(col.value),
  }
}

export const getMoreInformationContent = (tableRows, product) => {
  const content = []

  const hasFieldKeyAndNoValue = tableRows.some((row) => {
    return 'field' in row && getArrayValue(row.field, product)?.length === 0
  })
  // If there is a field but no value resolved then dont return any content
  if (hasFieldKeyAndNoValue) {
    return null
  }

  for (const tableRow of tableRows) {
    if (tableRow.field) {
      const fields = getArrayValue(tableRow.field, product)

      if (fields) {
        for (const field of fields) {
          const row = tableRow.fieldSchema.map((col) => {
            return { ...col, value: field[getValue(col.value, product)] }
          })

          content.push(row)
        }
      } else {
        return null
      }
    } else {
      const row = tableRow.data.map((col) => {
        return { ...col, value: getValue(col.value, product) }
      })

      content.push(row)
    }
  }

  return content.map((row) => row.map(applyFormat))
}

export const formatters: {
  [unit: string]: (value: number, count?: number) => string
} = {
  pounds: (value) => (value % 1 === 0 ? `£${value}` : `£${Number(value).toFixed(2)}`),

  // Alternative version of the pounds formatter that takes care of adding 0 as needed
  'full-pounds': (value) => `£${value.toFixed(2)}`,

  'pounds-with-commas': (value) =>
    Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value),

  percent: (value) => `${value}%`,

  /**
   * The simplicity of this funciton will need addressing in the future, however Kb, Mb, and Gb are
   * all proven on the Uswitch site.
   */
  'data-transfer': (kilobits = 0) => {
    if (kilobits < 1000) return `${kilobits || 0}Kb`
    if (kilobits >= 1e6) return `${Math.floor(kilobits / 1e6)}Gb`

    return `${Math.floor(kilobits / 1000)}Mb`
  },

  /**
   * The simplicity of this funciton will need addressing in the future, however MB and GB are all
   * proven on the Uswitch site.
   */
  data: (megabytes = 0) => {
    if (megabytes >= 1000) return `${Math.floor(megabytes / 1000)}GB`

    return `${megabytes || 0}MB`
  },

  'exchange-rate': (value, count = 4) => {
    // eslint-disable-next-line security/detect-non-literal-regexp
    const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${count}})?`)
    const matches = value.toString().match(regex)
    const withDecimals = matches?.length ? matches[0] : ''
    const [before = '', after = ''] = withDecimals.split('.')
    const val = `${before}.${after.padEnd(count, '0')}`

    return val
  },
}
